module.exports = __webpack_public_path__ + "img/erp_case4.ae027347.png";